import { defineStore } from "pinia";

export const useSystemStore = defineStore('system', {
  state: () => ({
    branches: [],
    ticketForms: [],
    customFields: [],
    ticketTemplates: [],
    tags: [],
    customerCustomFields: [],
    organizationCustomFields: [],
    customerLevels: [],
    departments: [],
    organizations: [],
    services: [],
    ticketCategories: [],
    customerEventTypes: [],
    customers_department: {},
    managers_department: {},
    systemSettings: {},
    license: {},
    settings: {},
    permissions: [],
    departmentsAdmin: [],
    workingshifts: [],
    countries: [],
    states: [],
    cities: [],
    loadingList: [],
    kbParentCategories: [],
    kbArticleCategories: [],
    kbCategories: [],
    connection: false,
    maintenanceText: '',
    announcementTypes: [
      { id: 1, title: 'کم', color: 'success' },
      { id: 2, title: 'عادی', color: 'yellow-darken-4' },
      { id: 3, title: 'زیاد', color: 'orange-darken-4' },
      { id: 4, title: 'بحرانی', color: 'error ' }
    ],
    satisfactionList: [
      { name: "نامشخص", id: 0 },
      { name: "كاملا ناراضي", id: 1 },
      { name: "ناراضي", id: 2 },
      { name: "متوسط", id: 3 },
      { name: "راضي", id: 4 },
      { name: "كاملا راضي", id: 5 },
    ],
    customfieldTypes: {
      text: { name: "کادر متنی یک خطی", icon: "icon-linetext", options: { min_length: null, max_length: null } },
      textArea: { name: "کادر متنی چند خطی", icon: "icon-lines-text", options: { min_length: null, max_length: null } },
      checkbox: { name: "چک باکس", icon: "icon-checkbox", options: {} },
      dropdown: { name: "منو کشویی", icon: "icon-dropdown", options: { items: [] } },
      number: { name: "عدد", icon: "icon-number", options: { min: null, max: null } },
      url: { name: "آدرس URL", icon: "link", options: {} },
      password: { name: "کلمه عبور", icon: "icon-key", options: {} },
      date: { name: "تاریخ", icon: "icon-date", options: { type: "date" } },
    },
    ticketStatuses: [
      { name: 'باز', id: 0 },
      { name: 'در حال انجام', id: 1 },
      { name: 'پاسخ کارشناس', id: 2 },
      { name: 'پاسخ مشتری', id: 3 },
      { name: 'بسته شده', id: 4 }
    ],
    importances: [
      { name: 'کم', id: 0, color: 'success' },
      { name: 'متوسط', id: 1, color: 'yellow-darken-4' },
      { name: 'زیاد', id: 2, color: 'orange-darken-4' },
      { name: 'بحرانی', id: 3, color: 'error' }
    ],
    mimeTypes: {
      "jpg": ["image/jpg"],
      "jpeg": ["image/jpeg"],
      "png": ["image/png"],
      "gif": ["image/gif"],
      "pdf": ["application/pdf"],
      "doc": ["application/msword"],
      "docx": ["application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
      "csv": ["text/csv", "application/csv", "application/vnd.ms-excel"],
      "xls": ["application/vnd.ms-excel"],
      "xlsx": ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
      "zip": ["application/zip", "application/x-zip-compressed"],
      "rar": ["application/vnd.rar", "application/x-rar-compressed", ""],
      "mp3": ["audio/mpeg"],
      "mp4": ["video/mp4"]
    },
  }),
  actions: {
    async setSystemDefaults(refresh = false) {
      if (!Object.keys(this.license).length || refresh)
        await useApi().systemDefaults().then(res => {
          if (res && res.status == 'OK') {
            this.customers_department = res.data.customers_department;
            this.managers_department = res.data.managers_department;
            this.license = res.data.license;
            this.ticketCategories = res.data.ticket_categories ?? [];
            this.ticketForms = res.data.ticket_forms ?? [];
            this.customFields = res.data.custom_fields ?? [];
            this.ticketTemplates = res.data.ticket_templates ?? [];
            this.customerEventTypes = res.data.customer_event_types ?? [];
            this.departments = res.data.departments ?? [];
            this.customerCustomFields = res.data.customer_custom_fields ?? [];
            this.organizationCustomFields = res.data.organization_custom_fields ?? [];
            this.customerLevels = res.data.customer_levels ?? [];
            this.organizations = res.data.organizations ?? [];
            this.services = res.data.services ?? [];
            this.branches = res.data.branches ?? [];
          }
        })
    },
    async setGlobalSettings(refresh = false) {
      if (!Object.keys(this.settings).length || refresh)
        await useApi().getSettings().then(res => {
          if (res && res.status == 'OK') this.settings = res.data;
        });
    },
    async setSystemSettings(refresh = false) {
      if (!Object.keys(this.systemSettings).length || refresh)
        await useApi().systemSettings().then(res => {
          if (res && res.status == 'OK') this.systemSettings = res.data;
        });
    },
    async setAdminDefaults(refresh = false) {
      if (!this.departmentsAdmin.length || refresh)
        await useApi().adminDefaults().then(res => {
          if (res && res.status == 'OK') {
            this.departmentsAdmin = res.data.departments;
            this.permissions = res.data.permissions;
          }
        });
    },
    async setWorkingshifts(refresh = false) {
      if (!this.workingshifts.length || refresh)
        await useApi().workingShiftList().then(res => {
          if (res && res.status == 'OK') this.workingshifts = res.data;
        });
    },
    async setStatesCities(refresh = false) {
      let functions = [];
      if (!this.countries.length || refresh)
        functions.push(useApi().countries().then(res => {
          if (res && res.status == 'OK') this.countries = res.data;
        }));
      if (!this.states.length || refresh)
        functions.push(useApi().states().then(res => {
          if (res && res.status == 'OK') this.states = res.data;
        }));
      if (!this.cities.length || refresh)
        functions.push(useApi().cities().then(res => {
          if (res && res.status == 'OK') this.cities = res.data;
        }));
      await Promise.all(functions);
    },
    async setTags(refresh = false) {
      if (!this.tags.length || refresh) {
        let res = await useApi().tagList();
        if (res && res.status == 'OK')
          this.tags = res.data;
      }
    },
    async createTag(name) {
      let res = await useApi().tagStore({ name });
      if (res && res.status == 'CREATED')
        this.tags.push({ id: res.data.id, name })
    },
    async deleteTag(id) {
      let res = await useApi().tagDelete(id);
      if (res && res.status == "DELETED")
        this.tags = this.tags.filter(x => x.id != id)
    },
    async setKbCategories(refresh = false) {
      if ((!this.kbCategories.length || refresh) && this.loadingList.indexOf('setKbCategories') == -1) {
        this.loadingList.push('setKbCategories');
        await useApi().kbCategoryList().then(async res => {
          if (res && res.status == "OK") {
            this.kbCategories = res.data;
          }
        }).finally(() => { this.loadingList.splice(this.loadingList.indexOf('setKbCategories'), 1) });
      }
    },
    async setKbParentCategories(refresh = false) {
      if ((!this.kbParentCategories.length || refresh) && this.loadingList.indexOf('setKbParentCategories') == -1) {
        this.loadingList.push('setKbParentCategories');
        await Promise.all([useApi().knowledgebaseCategoryList({ forCategories: 1, perPage: 999 }).then(async res => {
          if (res && res.status == "OK") {
            this.kbParentCategories = res.data;
          }
        }), useApi().knowledgebaseCategoryList({ forArticles: 1, perPage: 999 }).then(async res => {
          if (res && res.status == "OK") {
            this.kbArticleCategories = res.data;
          }
        })]).finally(() => { this.loadingList.splice(this.loadingList.indexOf('setKbParentCategories'), 1) });
      }
    },
    clearAdminDefaults() {
      this.departmentsAdmin = [];
      this.permissions = [];
    },
    clearWorkingshifts() {
      this.workingshifts = [];
    },
    updateCustomField(data) {
      this.customFields[this.customFields.findIndex(x => x.id == data.id)] = data;
    },
    pushCustomField(data) {
      this.customFields.push(data)
    },
    deleteCustomField(data) {
      this.customFields.splice(this.customFields.findIndex(x => x.id == data.id), 1)
    },
    clearSystemData() {
      this.customers_department = [];
      this.managers_department = [];
      this.license = {};
      this.ticketCategories = [];
      this.ticketForms = [];
      this.customFields = [];
      this.ticketTemplates = [];
      this.customerCustomFields = [];
      this.organizationCustomFields = [];
      this.customerEventTypes = [];
      this.tags = [];
      this.departments = [];
      this.customerLevels = [];
      this.organizations = [];
      this.services = [];
      this.branches = [];
      this.settings = {};
      this.departmentsAdmin = [];
      this.permissions = [];
      this.kbParentCategories = [];
      this.kbArticleCategories = [];
      this.kbCategories = [];
      this.workingshifts = [];
      this.countries = [];
      this.states = [];
      this.cities = [];
    },
    connectionChanged(data) {
      this.connection = data;
    },
    setMaintenanceText(data) {
      this.maintenanceText = data;
    }
  }
});
